import { CategoryItem } from 'ggApp/types/api/CategoryItem';

export const getCategoryFilterSuffix = (category: CategoryItem, isEUNonBusinessStore: boolean) =>
    isEUNonBusinessStore && category?.default_rental_plan_duration
        ? `?filter=${encodeURIComponent(
              new URLSearchParams({
                  rental_plan: `${category.default_rental_plan_duration}`,
              }).toString(),
          )}`
        : '';
